module.exports = __webpack_public_path__ + "static/img/2415(1).af23b46e.png";